import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { FC } from 'react';
import ReactTooltip from 'react-tooltip';

export type ToolBoxButtonProps = {
  toolTip?: string;
  label?: string;
  loadingMode: boolean;
  icon: IconDefinition;
  customStyle?: string;
  onClick: () => void;
};

const ToolBoxButton: FC<ToolBoxButtonProps> = ({
  toolTip = '',
  label = '',
  loadingMode,
  icon,
  customStyle,
  onClick,
}) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <div
      data-tip={toolTip}
      data-for='toggle-button'
      key='toggle-button'
      className={`toolbox-button`}
      onClick={onClick}>
      <ReactTooltip id='toggle-button' place='top' type='dark' effect='float' />
      <div className={`toolbox-btn-icon-container ${customStyle}`}>
        <FontAwesomeIcon className={`toggle ${loadingMode ? 'disabled' : ''} `} icon={icon} />
      </div>
      {!isMobile && <label>{label}</label>}
    </div>
  );
};

export default ToolBoxButton;
